import { App } from '@pay24/keep'
import React from 'react'
import { createRoot } from 'react-dom/client'

// noinspection JSCheckFunctionSignatures
createRoot(document.getElementById('root') as HTMLElement).render(<App />)
